module.exports = __webpack_public_path__ + "img/es.caa6452f.svg";